import bg from "img/bg.png";
import styled from "styled-components";

export const StyledTetrisWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background: url(${bg}) #000;
  background-size: cover;
  overflow: hidden;
`;
